if (!customElements.get("rv-quick-add-to-cart")){
    class RvQuickAddToCart extends HTMLElement{
        constructor(){
            super();
            this.url = this.dataset.url;
            this.sectionId = this.dataset.ajaxSectionId;

            this.formElement = null;
            this.content = null;
            this.variantJSONScriptEl = null;
            this.variantJSON = [];
            this.variantIdsJSON = [];
            this.productJSONScriptEl = null;
            this.productURLJSON = [];
            
            
            // Cache completed requests
            this.variantCache = new Map();
            this.productCache = new Map();
            // Cache requests that are currently running
            this.variantRequests = new Map();
            this.productRequests = new Map();
            
            this.isInitialized = false;
            this.doesPrefetchVariants = false;
            this.doesPrefetchProducts = false;

            this.handlevariantChange = this.handlevariantChange.bind(this);
            this.handleProductChange = this.handleProductChange.bind(this);
            this.handleAddToCart = this.handleAddToCart.bind(this);

            this.cart = document.querySelector("cart-notification") || document.querySelector("cart-drawer");
        }

        connectedCallback(){
            if (this.isInitialized) return;

            if (document.readyState === "loading") {
                document.addEventListener("DOMContentLoaded", () => this.init(), { once: true });
            } else {
                this.init();
            }
        }
        
        disconnectedCallback(){
            this.removeEventListener("input", this.handlevariantChange);
        }
        
        init(){
            this.formElement = this.querySelector("form");

            this.variantJSONScriptEl = this.querySelector("[data-variants]");
            this.productJSONScriptEl = this.querySelector("[data-sibling-products]");
            this.content = this.querySelector("[data-quick-add-content]");
            if (!this.variantJSONScriptEl) {
                console.warn('Variant JSON script not found', this);
                return;
            }

            // console.log(this.variantJSONScriptEl.textContent);
            try {
                this.variantJSON = JSON.parse(this.variantJSONScriptEl.textContent || '[]');
                this.variantIdsJSON = this.variantJSON.map(variant => variant.id);
                // console.log(this.variantIdsJSON);
            } catch (error) {
                console.error('Invalid variant JSON', error);
                return;
            }
            try {
                this.productURLJSON = JSON.parse(this.productJSONScriptEl.textContent || '[]');
                this.productURLJSON = this.productURLJSON.map(productObj => productObj.url);
                // console.log(this.productURLJSON);
            } catch (error) {
                console.error('Invalid product JSON', error);
                return;
            }
            this.addEventListener("input", this.handlevariantChange);
            document.addEventListener("quick-add-to-cart-product:change", this.handleProductChange);
            this.formElement.addEventListener("submit", this.handleAddToCart.bind(this));

            this.isInitialized = true;

             // Start prefetching after initialization
            this.prefetchVariants();
            this.PrefetchProducts();
        }

        async handlevariantChange({target}){
            if (!target) return;
            if (DEBUG) console.debug("============================== START: HANDLE VARIANT CHANGE ==============================");
            
            target.closest(".ui-tile")?.setAttribute("data-state", "loading");
            
            const variant =  this.selectedVariant();
            if (!variant) return;
            
            const variantId = variant.id;
            const HTMLFromSource = await this.fetchVariant(variantId);
            this.updateContent(HTMLFromSource);
            target.closest(".ui-tile")?.removeAttribute("data-state");

            if (!this.doesPrefetchVariants){
                this.prefetchVariants();
            }

            if (DEBUG){
                console.debug("variant Id: ", variantId);
                console.debug(HTMLFromSource);
            }
            if (DEBUG) console.debug("================================ END: HANDLE VARIANT CHANGE ==============================");
        }

        async handleProductChange(event){
            // console.log("Product Change");
            // console.log(event);
            const url = event?.detail?.data?.url;
            const target = event?.detail?.data?.target;
            // console.log(target);
            // console.log(url);

            const HTMLFromSource = await this.fetchProduct(url);
            this.updateContent(HTMLFromSource, url);
        }

async handleAddToCart(event) {
    // console.log(event);
    event.preventDefault();
    event.stopPropagation();

    event.submitter?.setAttribute("data-state", "loading");

    // console.log("ADD TO CART INTERCEPTED");

    const formData = new FormData(this.formElement);

    // Only send the fields Shopify needs
    const data = {
        id: formData.get("id"),
        quantity: Number(formData.get("quantity") || 1)
    };

    if (this.cart) {
        data["sections"] = this.cart.getSectionsToRender().map((section) => section.id);
        data["sections_url"] = window.location.pathname;
          this.cart.setActiveElement(document.activeElement);
        }

    try {
        const response = await fetch("/cart/add.js", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "X-Requested-With": "XMLHttpRequest"
            },
            body: JSON.stringify(data)
        });

        const result = await response.json();

        // Shopify cart error
        if (!response.ok || result.status) {
            console.error("Add to cart failed:", result.description);
            const wrapper = this.querySelector("[data-error-wrapper]");
            const msg= this.querySelector("[data-error-msg]");
            msg.textContent = result.description;
            // console.log(wrapper);
            wrapper?.classList.remove("tw-hidden");
            wrapper?.classList.add("tw-flex");
            wrapper?.scrollIntoView({
                behavior: "smooth",
                block: "center"
            });
            setTimeout(() => {
                wrapper?.classList.remove("tw-flex");
                wrapper?.classList.add("tw-hidden");
            }, 10000);
            return;
        }
        if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }


        event.submitter.setAttribute("data-state", "success"); 
        // console.log("Added to cart:", result);
        setTimeout(()=>{
            if (this.cart && this.cart.classList.contains("is-empty")){
                this.cart.classList.remove("is-empty");
            }
            this.closeOverlayBtn = this.querySelector("[data-overlay-close]");
            this.closeOverlayBtn?.click();
            // console.log("thos close overlaty", this.closeOverlayBtn);
            this.cart.renderContents(result);
        }, 500)

    } catch (error) {
        console.error("Add to cart error:", error);
    }finally{
        setTimeout(()=>{
            event.submitter.removeAttribute("data-state");
        }, 3000)
        
    }
}

        selectedVariant(){
            const selectedOptionValues = this.getSelectedOptions();
            const variant = this.findVariant(selectedOptionValues);
            
            if (DEBUG){
                console.debug("Variants JSON",this.variantJSON);
                console.debug("Selected Options",selectedOptionValues);
                console.debug("Selected Variant", variant);
            }
            
            if (variant){
                return variant;
            }else{
                return null;
            }
        }

        getSelectedOptions() { 
            const selectedOptions = {};

            this.querySelectorAll('input:checked')
            .forEach((input) => {
                const position = Number(input.dataset.position);
                if (!position) return;

                selectedOptions[position] = input.value;});

                return selectedOptions;
            }

        findVariant(selectedOptions) {
            return this.variantJSON.find((variant) => {
                const variantOptions = [variant.option1, variant.option2, variant.option3]
                .filter((option) => option !== null &&option !== undefined);

                const selectedOptionValues = Object.keys(selectedOptions)
                    .sort((a, b) => Number(a) - Number(b))
                    .map((position) => selectedOptions[position]);

                if (variantOptions.length !== selectedOptionValues.length) {
                    return false;
                }

                return variantOptions.every((option, index) =>
                    option === selectedOptionValues[index]);
                });
        }

        async prefetchVariants() {
            if (this.doesPrefetchVariants) return;

            this.doesPrefetchVariants = true;

            const variantIds = this.variantIdsJSON;

            if (!variantIds.length) return;

            if (DEBUG) {
                console.debug(
                    "Starting variant prefetch:",
                    variantIds
                );
            }

            // Don't make the browser wait for all of these.
            await Promise.allSettled(
                variantIds.map(variantId =>
                    this.fetchVariant(variantId)
                )
            );

            if (DEBUG) {
                console.debug("Variant prefetch completed");
            }
        }

        async fetchVariant(variantId){
            if (!variantId || !this.dataset.url) return null;

            /*
             * 1. Already fetched?
             */
            if (this.variantCache.has(variantId)) {
                if (DEBUG) {
                    console.debug("Using cached variant:", variantId);
                }

                return this.variantCache.get(variantId);
            }

            /*
             * 2. Already being fetched?
             *
             * This is important because prefetchVariants() might already
             * be fetching the same variant that the user selects.
             */
            if (this.variantRequests.has(variantId)) {
                if (DEBUG) {
                    console.debug("Waiting for existing request:", variantId);
                }

                return this.variantRequests.get(variantId);
            }

            /*
             * 3. Create request
             */
            const request = this.requestVariant(variantId);

            this.variantRequests.set(variantId, request);

            try {
                const html = await request;

                /*
                 * Store successful response
                 */
                this.variantCache.set(variantId, html);

                return html;
            } catch (error) {
                console.error(`Failed to fetch variant ${variantId}`, error);

                return null;
            } finally {
                /*
                 * Remove from in-flight requests
                 */
                this.variantRequests.delete(variantId);
            }
        }

        async requestVariant(variantId) {
            if (DEBUG) {
                console.debug("Fetching variant:", variantId);
            }

            const url = new URL(this.dataset.url, window.location.origin);
            url.searchParams.set("section_id", this.sectionId);
            url.searchParams.set("variant", variantId);

            const response = await fetch(url.toString());

            if (!response.ok) {
                throw new Error(
                    `Variant request failed: ${response.status}`
                );
            }

            return response.text();
        }


        async PrefetchProducts() {
            if (this.doesPrefetchProducts) return;

            this.doesPrefetchProducts = true;

            const productURLJSON = this.productURLJSON;

            if (!productURLJSON.length) return;

            if (DEBUG) {
                console.debug(
                    "Starting product prefetch:",
                    productURLJSON
                );
            }

            // Don't make the browser wait for all of these.
            await Promise.allSettled(
                productURLJSON.map(productURL =>
                    this.fetchProduct(productURL)
                )
            );

            if (DEBUG) {
                console.debug("Product prefetch completed");
            }

        }

        async fetchProduct(productURL){

            /*
             * 1. Already fetched?
             */
            if (this.productCache.has(productURL)) {
                if (DEBUG) {
                    console.debug("Using cached productURL:", productURL);
                }

                return this.productCache.get(productURL);
            }

             if (this.productRequests.has(productURL)) {
                if (DEBUG) {
                    console.debug("Waiting for existing request:", productURL);
                }

                return this.productRequests.get(productURL);
            }

             /*
             * 3. Create request
             */
            const request = this.requestProduct(productURL);

            this.productRequests.set(productURL, request);

            try {
                const html = await request;

                /*
                 * Store successful response
                 */
                this.productCache.set(productURL, html);

                return html;
            } catch (error) {
                console.error(`Failed to fetch Product ${productURL}`, error);

                return null;
            } finally {
                /*
                 * Remove from in-flight requests
                 */
                this.productRequests.delete(productURL);
            }
        }

        async requestProduct(productURL){
            if (DEBUG) {
                console.debug("Fetching product:", productURL);
            }

            const url = new URL(productURL, window.location.origin);
            url.searchParams.set("section_id", this.sectionId);

            const response = await fetch(url.toString());

            if (!response.ok) {
                throw new Error(
                    `Product request failed: ${response.status}`
                );
            }

            return response.text();
        }

        updateContent(html, url){
            const htmlX = new DOMParser().parseFromString(html, "text/html");
            const contentFromhtml = htmlX.querySelector("[data-quick-add-content]");

            const productMedia = this.content.querySelector("[data-desktop-product-media]");
            const mediaScrollTop = productMedia?.scrollTop ?? 0;
            const productMediaMobile = this.content.querySelector("[data-mobile-product-media]");
            const mediaScrollLeft = productMediaMobile?.scrollLeft ?? 0;
            const productInfo = this.content.querySelector("[data-product-info]");
            const scrollTop = productInfo?.scrollTop ?? 0;

            const colorSwatchesFromDOM = this.content.querySelector(
            "[data-color-swatches-wrapper]"
        );
            if (url){
        
            const activeSwatch = colorSwatchesFromDOM.querySelector(`.ui-swatch[data-selected]`);
            const currentSwatch = colorSwatchesFromDOM.querySelector(`.ui-swatch[data-url="${url}"]`);

            if (activeSwatch != currentSwatch){
                activeSwatch?.removeAttribute("data-selected")
                currentSwatch?.setAttribute("data-selected", true);
            }
        
        }
        const colorSwatchesFromHTML = contentFromhtml.querySelector(
                "[data-color-swatches-wrapper]"
            );
        if (colorSwatchesFromDOM && colorSwatchesFromHTML) {
            colorSwatchesFromHTML.replaceWith(
                colorSwatchesFromDOM.cloneNode(true)
            );
        }

            requestAnimationFrame(() => {
                // this.content.innerHTML = contentFromhtml.innerHTML;
                const fragment = document.createDocumentFragment();

                fragment.append(
                    ...contentFromhtml.cloneNode(true).childNodes
                );

                this.content.replaceChildren(fragment);
            
                // Restore scroll on newly created element
                const newProductInfo = this.content.querySelector("[data-product-info]");
                const newproductMedia = this.content.querySelector("[data-desktop-product-media]");
                const newproductMediaMobile = this.content.querySelector("[data-mobile-product-media]");

                console.log(newproductMediaMobile);
                console.log(mediaScrollLeft);
                if (newProductInfo) {
                    newProductInfo.scrollTop = scrollTop;
                }
                if (newproductMedia){
                    newproductMedia.scrollTop = mediaScrollTop;
                }
                if (newproductMediaMobile){
                    newproductMediaMobile.scrollLeft = mediaScrollLeft;
                }

                if (url){
                    this.dataset.url = url;
                    this.doesPrefetchVariants = false;
                    this.variantJSONScriptEl = this.querySelector("[data-variants]");
                    this.content = this.querySelector("[data-quick-add-content]");
                    if (!this.variantJSONScriptEl) {
                        console.warn('Variant JSON script not found', this);
                        return;
                    }

                    // console.log(this.variantJSONScriptEl.textContent);
                    try {
                        this.variantJSON = JSON.parse(this.variantJSONScriptEl.textContent || '[]');
                        this.variantIdsJSON = this.variantJSON.map(variant => variant.id);
                        // console.log(this.variantIdsJSON);
                    } catch (error) {
                        console.error('Invalid variant JSON', error);
                        return;
                    }
                }
                this.formElement = this.querySelector("form");
                if (this.formElement) {
                    this.formElement.addEventListener(
                        "submit",
                        this.handleAddToCart
                    );
                }
            });
            }


    }
    customElements.define("rv-quick-add-to-cart", RvQuickAddToCart);
}